'use client';

import { useLingui } from '@lingui/react/macro';
import { useLayout } from '@/components/context/layout';
import { useMemo } from 'react';
import { linksByI18n, OptionsType } from './use-localized-links';

const useLocalizedLinks = (option?: OptionsType) => {
  const { i18n } = useLingui();
  const [{ utm }] = useLayout();
  return useMemo(() => {
    return linksByI18n(i18n as any, { utm, ...option });
  }, [i18n, option, utm]);
};

export default useLocalizedLinks;
